import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import {useDispatch} from 'react-redux';
import {useContactsContext} from '../ContactsContext';
import PopupAddContact from '../PopupAddContact/PopupAddContact';
import {InputCheckbox} from '../../../_common/components/FieldCheckbox';
import FilterText from '../../../_common/components/FilterText';
import FilterSelect from '../../../_common/components/FilterSelect';
import {applyFilter} from '../../../../../utils/prepareApplyFilter';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ButtonAction from '../../../_common/components/ButtonAction';
import {getContactsListForExcel} from '../../actions/ContactsActions';
import {generateExcelFile} from '../../../_common/utils/excel';
import {columnNamesContacts} from '../../../_common/constants/excelColumnNames';
import styles from '../../../_common/styles/filtersBar.module.scss';

export function ContactsFilters() {
  const contactsContext = useContactsContext();
  const contactsProps = useMemo(() => {
    return {
      queryParams: contactsContext.queryParams,
      setQueryParams: contactsContext.setQueryParams,
    };
  }, [contactsContext]);
  const [loading, setLoading] = useState(false);

  const intl = useIntl();
  const dispatch = useDispatch();
  const prefix = 'filter-placeholder';

  const qs = new URLSearchParams(window.location.search);
  let name = qs.get('name') || '';
  let phone = qs.get('phone') || '';
  let job = qs.get('job') || '';
  let organization = qs.get('organization') || '';
  let email = qs.get('email') || '';
  let statusID = qs.get('statusID') || '';
  let deleted = qs.get('deleted') || '';

  const handleExport = () => {
    setLoading(true);
    dispatch(getContactsListForExcel(contactsProps.queryParams))
      .then(prepareDataForExcel)
      .then((data) => {
        generateExcelFile(
          data,
          'Contacts.xlsx',
          'אנשי קשר'
        );
      })
      .catch((error) => {
        console.error(`Error: + ${error}`);
      }).finally(() => setLoading(false));
  };
  const prepareDataForExcel = data => {
    return data.map((item, index) => {
      const {
        contactID,
        firstName,
        lastName,
        phone,
        email,
        job,
        organization,
        address,
        statusName
      } = item;

      return {
        [columnNamesContacts[0]]: index + 1,
        [columnNamesContacts[1]]: contactID || '',
        [columnNamesContacts[2]]: [firstName, lastName].filter(Boolean).join(' '),
        [columnNamesContacts[3]]: phone || '',
        [columnNamesContacts[4]]: email || '',
        [columnNamesContacts[5]]: job || '',
        [columnNamesContacts[6]]: organization || '',
        [columnNamesContacts[7]]: address || '',
        [columnNamesContacts[8]]: statusName || '',
      };
    });
  };

  return (
    <Formik
      initialValues={{
        name,
        phone,
        job,
        organization,
        email,
        statusID,
        deleted,
      }}
      onSubmit={(values) => applyFilter(values, contactsProps)}
      enableReinitialize={true}
    >
      {({values, handleBlur, handleSubmit, setFieldValue}) => (
        <form onSubmit={handleSubmit} className={styles.container}>
          <div className={styles.filtersContainer}>
            <FilterText
              fieldName={'name'}
              value={values.name}
              placeholder={intl.formatMessage({id: `${prefix}-name`, defaultMessage: 'Name'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'phone'}
              value={values.phone}
              type={'number'}
              placeholder={intl.formatMessage({id: `${prefix}-phone`, defaultMessage: 'Phone'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'email'}
              value={values.email}
              placeholder={intl.formatMessage({id: `${prefix}-email`, defaultMessage: 'Email'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'job'}
              value={values.job}
              placeholder={intl.formatMessage({id: `${prefix}-job`, defaultMessage: 'Job'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterText
              fieldName={'organization'}
              value={values.organization}
              placeholder={intl.formatMessage({id: `${prefix}-organization`, defaultMessage: 'Organization'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <FilterSelect
              fieldName={'statusID'}
              valueName={values.statusID}
              options={contactsContext.contactStatusTypes}
              placeholder={intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
              containerClassnames={styles.filter}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              handleSubmit={handleSubmit}
            />
            <InputCheckbox
              fieldId={'deleted'}
              value={values.deleted}
              label={intl.formatMessage({id: `${prefix}-deleted`, defaultMessage: 'With deleted contacts'})}
              onChange={() => {
                setFieldValue('deleted', !values.deleted);
                handleSubmit();
              }}
              customContainerStyles={styles.filter}
            />
          </div>
          <div className={styles.buttonsContainer}>
            <PopupAddContact
              buttonVariant={'primary'}
              customLabel={
                <div>
                  <img src={toAbsoluteUrl('/media/common/Plus_white.svg')} alt="create" className={'mr-2'}/>
                  <span>{intl.formatMessage({id: 'contacts-popup-add-row', defaultMessage: 'Add contact'})}</span>
                </div>
              }
            />
            <ButtonAction
              variant={'success'}
              label={
                <>
                  {loading
                    ? (
                      <div className="spinner-border spinner-border-md m-auto text-light" role="status"/>
                    )
                    : (
                      <>
                        <img
                          src={toAbsoluteUrl('/media/common/Excel_white.svg')}
                          alt="export" className={'mr-2'}
                        />
                        <span>{intl.formatMessage({id: 'button-export-to-excel', defaultMessage: 'Export'})}</span>
                      </>
                    )
                  }
                </>
              }
              onClick={handleExport}
              customClassnames={'w-100px ml-4'}
            />
          </div>
        </form>
      )}
    </Formik>
  );
}

export default ContactsFilters;